<template>
  <div id="app" @click="handleClickOutsideMenu">
    <nav class="navbar">
      <div class="brand-and-links">
        <div class="hamburger" @click.stop="toggleMenu">
          <i class="fas fa-bars"></i>
        </div>
        <router-link to="/" class="brand-link" @click="closeMenu">
          <img src="@/assets/CSP_Logo_White_trans.png" alt="Logo" class="logo">
          <span class="brand-name">Clear Skies Practice</span>
        </router-link>
        <ul class="nav-links" :class="{ 'nav-active': menuActive }" ref="menu">
          <li><router-link to="/therapy" @click="closeMenu">Therapy</router-link></li>
          <li><router-link to="/couplestherapy" @click="closeMenu">Couple Therapy</router-link></li>
          <li><router-link to="/life-coaching" @click="closeMenu">Coaching</router-link></li>
          <li><router-link to="/about-me" @click="closeMenu">About Me</router-link></li>
          <li><router-link to="/contact" @click="closeMenu">Contact</router-link></li>
          <li><router-link to="/testimonials" @click="closeMenu">Testimonials</router-link></li>
          <li class="dropdown">
          <span @click.stop="toggleDropdown('info')">
            Info <i class="fas fa-caret-down"></i>
          </span>
          <ul class="dropdown-content" :class="{ 'show-dropdown': activeDropdown === 'info' }">
            <li><router-link to="/documents" @click="closeMenu">Documents</router-link></li>
            <li><router-link to="/privacy" @click="closeMenu">Privacy Policy</router-link></li>
            <li><router-link to="/business" @click="closeMenu">Fees and Business Terms</router-link></li>
            <li><router-link to="/faq" @click="closeMenu">Frequently Asked Questions</router-link></li>
          </ul>
        </li>

        <li class="dropdown">
          <span @click.stop="toggleDropdown('resources')">
            Free Resources <i class="fas fa-caret-down"></i>
          </span>
          <ul class="dropdown-content" :class="{ 'show-dropdown': activeDropdown === 'resources' }">
            <li><a href="/csrelax-app/" @click="closeMenu">Clear Skies - App</a></li>
          </ul>
        </li>
        </ul>
      </div>
    </nav>
    <div class="content">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/FooterPage.vue';

export default {
  name: 'App',
  components: {
    Footer
  },
  data() {
    return {
      menuActive: false,
      activeDropdown: null
    };
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
      if (!this.menuActive) {
        this.activeDropdown = null;
      }
    },
    toggleDropdown(name) {
      this.activeDropdown = this.activeDropdown === name ? null : name;
    },
    closeMenu() {
      this.menuActive = false;
      this.activeDropdown = null;
    },
    handleClickOutsideMenu(event) {
      const menu = this.$refs.menu;
      if (this.menuActive && menu && !menu.contains(event.target)) {
        this.closeMenu();
      }
    }
  }
}
</script>

<style>
  /* Default links behave like text, not browser chrome */
a {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
}

a:hover {
  text-decoration-thickness: 2px;
}

a:visited {
  color: inherit;
}

</style>
<style scoped>
@import '~@fortawesome/fontawesome-free/css/all.css';

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #5DAED5;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.brand-and-links {
  display: flex;
  align-items: center;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo {
  height: 40px; /* Adjust as needed */
}

.brand-name {
  color: white;
  font-size: 20px;
  margin-left: 10px;
}

.hamburger {
  display: none;
  font-size: 30px;
  color: white;
  cursor: pointer;
  margin-right: 10px;
}

.nav-links {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.nav-links li {
  margin: 0 15px;
  position: relative;
}

.nav-links li a, .nav-links li span {
  display: block;
  color: white;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  cursor: pointer;
}

.nav-links li a:hover, .nav-links li span:hover {
  background-color: #359ACB;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #359ACB;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  min-width: 160px;
  list-style-type: none; /* Remove bullet points */
  padding: 0; /* Remove padding */
}

.dropdown-content li {
  margin: 0;
}

.dropdown-content li a {
  padding: 12px 16px;
}

.show-dropdown {
  display: block;
}

.content {
  margin-top: 70px; /* Adjust this value if your navbar height changes */
}

.image-card {
  width: 40%;
  overflow: hidden;            /* hide any overshoot */
}

.image-card img {
  display: block;              /* remove inline-img whitespace */
  width: 100%;                 /* fill the width of the card */
  height: auto;
  max-height: clamp(200px, 50vh, 400px);
  object-fit: cover;           /* crop nicely if needed */
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .nav-links {
    display: none;
    flex-direction: column;
    width: 100%;
    position: absolute;
    top: 60px;
    left: 0;
    background-color: #359ACB;
  }

  .nav-links.nav-active {
    display: flex;
  }

  .nav-links li {
    margin: 2px 0;
  }

  .nav-links li a,
  .nav-links li span {
    font-size: 16px;
    padding: 10px 16px;
    line-height: 1.2;
  }

  .hamburger {
    display: block;
  }

  .dropdown-content {
    position: static;
    box-shadow: none;
  }

  .dropdown-content li a {
    font-size: 15px;
    padding: 8px 16px;
  }
}
</style>
